import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics';

import { getFirebaseApp } from './app';
import { getFirebaseEnvConfig } from './config';

type AnalyticsGlobalState = typeof globalThis & {
  __verdeconfirmaAnalytics?: Promise<Analytics | null>;
  __verdeconfirmaAnalyticsInstance?: Analytics | null;
};

const firebaseGlobal = globalThis as AnalyticsGlobalState;

export function initializeFirebaseAnalytics(): Promise<Analytics | null> {
  if (firebaseGlobal.__verdeconfirmaAnalytics) {
    return firebaseGlobal.__verdeconfirmaAnalytics;
  }

  const config = getFirebaseEnvConfig();

  if (!config.measurementId) {
    firebaseGlobal.__verdeconfirmaAnalyticsInstance = null;
    firebaseGlobal.__verdeconfirmaAnalytics = Promise.resolve(null);
    return firebaseGlobal.__verdeconfirmaAnalytics;
  }

  firebaseGlobal.__verdeconfirmaAnalytics = isSupported().then((supported) => {
    if (!supported) {
      firebaseGlobal.__verdeconfirmaAnalyticsInstance = null;
      return null;
    }

    const analytics = getAnalytics(getFirebaseApp());
    firebaseGlobal.__verdeconfirmaAnalyticsInstance = analytics;

    return analytics;
  });

  return firebaseGlobal.__verdeconfirmaAnalytics;
}

export function getFirebaseAnalytics(): Analytics | null {
  return firebaseGlobal.__verdeconfirmaAnalyticsInstance ?? null;
}
